import { toJS } from 'mobx'
import React, { Component } from 'react'
import { loadScript } from '@hlj/hlj-utils'
/*
 图表通用组件，提供的属性有:
 option:参考echart的配置option
 style:图表外层容器的样式
 afterInit:(当你想获取图表实例,可以提供此属性)当图表初始化完毕后会调用此方法，参数是初始化之后的chart实例
 header:图表头部工具栏,如果图表需要额外的操作，操作工具栏可以写在这,可以是react组件
 */
export default class Chart extends Component {
  chart
  static defaultProps = {
    headerHeight: 40,
    toolbox: true,
    option: {}
  }
  resizeChart = () => {
    this.chart.resize()
  }

  drawChart(option) {
    option = option || {}
    if (this.chart) {
      const { toolbox } = this.props
      if (!option.toolbox && toolbox) {
        option.toolbox =
          toolbox === true
            ? {
                show: true,
                feature: {
                  dataZoom: {
                    yAxisIndex: 'none'
                  },
                  dataView: { readOnly: false },
                  magicType: { type: ['line', 'bar'] },
                  restore: {},
                  saveAsImage: {}
                }
              }
            : toolbox
      }
      this.chart.setOption(toJS(option)) //true
    }
  }

  init() {
    const { afterInit, option, onClick } = this.props
    this.chart = echarts.init(this.chartEl)
    afterInit && afterInit(this.chart)
    window.addEventListener('resize', this.resizeChart)
    this.drawChart(option)
    if (onClick) {
      this.chart.on('click', e => {
        onClick(e)
      })
    }
  }

  componentDidMount() {
    if (window.echarts) {
      this.init()
    } else {
      loadScript('//qnc.hunliji.com/echarts.min.js', () => {
        this.init()
      })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.drawChart(nextProps.option)
  }

  shouldComponentUpdate = () => false

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeChart)
  }

  getEl = chartEl => {
    this.chartEl = chartEl
  }

  render() {
    const { style, header, headerHeight, chartContainerStyle } = this.props
    let styles = {
      margin: '20px 0 20px 0',
      height: 500,
      ...style
    }
    let headerStyles = {
      position: 'relative',
      height: headerHeight,
      marginBottom: 10,
      background: '#f5f5f5',
      borderRadius: 5,
      padding: 5,
      fontSize: 14
    }
    return (
      <div style={styles}>
        {header && <header style={headerStyles}>{header}</header>}
        <div
          style={{
            ...chartContainerStyle,
            height: header ? styles.height - headerHeight - 10 : '100%'
          }}
          ref={this.getEl}
        />
      </div>
    )
  }
}
